import { Component } from '@angular/core';
import { faUser, faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { faTwitter, faGithub, faLinkedin, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { MatDialog } from '@angular/material/dialog';
import { HubspotSubscribeDialogComponent } from '../dialogs/hubspot-subscribe-dialog/hubspot-subscribe-dialog.component';

@Component({
  selector: 'realwear-cloud-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  public readonly faUser = faUser;
  public readonly faEnvelope = faEnvelope;
  public readonly faTwitter = faTwitter;
  public readonly faLinkedin = faLinkedin;
  public readonly faYoutube = faYoutube;
  public readonly faGithub = faGithub;

  constructor(private dialog: MatDialog) {}

  openSubscribeDialog() {
    this.dialog.open(HubspotSubscribeDialogComponent, { width: '400px' });
  }
}
